import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { TargetedInviteAcceptPage } from '@/features/groups/components';

function TargetedInviteAcceptRoute(): ReactNode {
  const { inviteId } = Route.useParams();
  return <TargetedInviteAcceptPage inviteId={inviteId} />;
}

export const Route = createFileRoute('/invites/direct/$inviteId')({
  component: TargetedInviteAcceptRoute,
});
